/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type AIConfigTargetingEnvironmentRuleClause = {
  attribute: string;
  id: string;
  negate: boolean;
  op: string;
  values: Array<any>;
};

/** @internal */
export const AIConfigTargetingEnvironmentRuleClause$inboundSchema: z.ZodType<
  AIConfigTargetingEnvironmentRuleClause,
  z.ZodTypeDef,
  unknown
> = z.object({
  attribute: z.string(),
  id: z.string(),
  negate: z.boolean(),
  op: z.string(),
  values: z.array(z.any()),
});
/** @internal */
export type AIConfigTargetingEnvironmentRuleClause$Outbound = {
  attribute: string;
  id: string;
  negate: boolean;
  op: string;
  values: Array<any>;
};

/** @internal */
export const AIConfigTargetingEnvironmentRuleClause$outboundSchema: z.ZodType<
  AIConfigTargetingEnvironmentRuleClause$Outbound,
  z.ZodTypeDef,
  AIConfigTargetingEnvironmentRuleClause
> = z.object({
  attribute: z.string(),
  id: z.string(),
  negate: z.boolean(),
  op: z.string(),
  values: z.array(z.any()),
});

export function aiConfigTargetingEnvironmentRuleClauseToJSON(
  aiConfigTargetingEnvironmentRuleClause:
    AIConfigTargetingEnvironmentRuleClause,
): string {
  return JSON.stringify(
    AIConfigTargetingEnvironmentRuleClause$outboundSchema.parse(
      aiConfigTargetingEnvironmentRuleClause,
    ),
  );
}
export function aiConfigTargetingEnvironmentRuleClauseFromJSON(
  jsonString: string,
): SafeParseResult<AIConfigTargetingEnvironmentRuleClause, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) =>
      AIConfigTargetingEnvironmentRuleClause$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AIConfigTargetingEnvironmentRuleClause' from JSON`,
  );
}
